ACC.placeorder = {

	bindAll: function ()
	{
		this.updatePlaceOrderButton();
		this.bindSecurityCodeWhatIs();
		this.bindOciFormSubmit();
	},

	updatePlaceOrderButton: function ()
	{
		
		$(".place-order").removeAttr("disabled");
		// need rewrite /  class changes
	},

	bindSecurityCodeWhatIs: function ()
	{
		$('.security_code_what').bt($("#checkout_summary_payment_div").data("securityWhatText"),
				{
					trigger: 'click',
					positions: 'bottom',
					fill: '#efefef',
					cssStyles: {
						fontSize: '11px'
					}
				});
	},

    bindOciFormSubmit: function () {
        $('#ociBuyerForm').submit();
    }

};

$(document).ready(function ()
{
	ACC.placeorder.bindAll();
});


